import { render, staticRenderFns } from "./platBar.vue?vue&type=template&id=f660bfec&"
import script from "./platBar.vue?vue&type=script&lang=js&"
export * from "./platBar.vue?vue&type=script&lang=js&"
import style0 from "./platBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports